import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../auth/_services/authentication.service";
import { Router , ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { appService } from "../../_services/app.service";
@Component({
  selector: 'app-ssologin',
  templateUrl: './ssologin.component.html',
  styleUrls: ['./ssologin.component.scss']
})
export class SsologinComponent implements OnInit {
  uname:any;
  pass:any;
  showError = 0;
  loading = false;
  flag: any;
  returnUrl: string = '/index';
  constructor(
    private service: AuthenticationService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private toast: ToastrService,
    private _appService: appService,
  ) {
    this.activatedRoute.paramMap.subscribe(async params => {
      this.uname = this.activatedRoute.snapshot.queryParams['Id'];
      this.pass = this.activatedRoute.snapshot.queryParams['code'];
      this.ssoLogin(this.uname , this.pass);
    });
  }

  ngOnInit() {
  }

  ssoLogin(username , password) {
    this.loading = true;
    this.service.login(username , password).subscribe((res) => {
      this.toast.success("SSO Login success");
      this.route.navigate(['/index']);
      this._appService
          .Get("FuelPrice", "CheckFuelFlag")
          .subscribe(Response => {
            this.flag = Response;
          });
      this.loading = false;
    } , (err) => {
      this.showError = 1;
      this.loading = false;
      this.toast.error("SSO Login Failed , wrong email or password");
    });
  }

}
